import React from 'react';
import { PanelType } from "@fluentui/react";
import { StandarPanel } from '@ioip/core/lib';

export interface IPopupPanelProps {
  onCancel: () => void;
  onAccept: () => void;
  title: string;
  text: string;
  show: boolean;
  closeButtonText?: string
}

const PopupPanel = (props: IPopupPanelProps): JSX.Element => {
  return <StandarPanel
    isOpen={props.show}
    type={PanelType.largeFixed}
    headerText={props.title}
    onClose={() => props.onCancel()}
    onAccept={() => props.onAccept()}
    closeButtonText = {props.closeButtonText ? props.closeButtonText : ''}
  >
    <div
      dangerouslySetInnerHTML={{ __html: props.text.split('####').join('<br /><br />') }}
    />
  </StandarPanel>
}

export default PopupPanel;